var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      minWidth: 47
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 133 133"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_svg__logo-gradient",
    x1: 403.11,
    y1: 477.84,
    x2: 403.11,
    y2: 714.12,
    gradientTransform: "rotate(-15.25 -1271.853 1229.872)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#14fdee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01d0ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_svg__logo-gradient-2",
    x1: 355.36,
    y1: 671.84,
    x2: 393.92,
    y2: 671.84,
    gradientTransform: "rotate(-15.25 -1271.853 1229.872)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0080af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33b0cc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_svg__logo-gradient-3",
    x1: 353.65,
    y1: 542.43,
    x2: 535.01,
    y2: 580.98,
    xlinkHref: "#logo_svg__logo-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_svg__logo-gradient-4",
    x1: 356.77,
    y1: 617.02,
    x2: 458.4,
    y2: 617.02,
    xlinkHref: "#logo_svg__logo-gradient-2"
  }), /*#__PURE__*/React.createElement("style", null, ".logo_svg__cls-1{fill:url(#logo_svg__logo-gradient)}.logo_svg__cls-2{fill:url(#logo_svg__logo-gradient-2)}.logo_svg__cls-3{fill:url(#logo_svg__logo-gradient-3)}.logo_svg__cls-4{fill:url(#logo_svg__logo-gradient-4)}.logo_svg__cls-5{fill:none}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.477 39.691v88.547L24.918 104.23V15.676zm0 0",
    fillRule: "evenodd",
    fill: "#1daeff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87.055 26.023 41.879 0v18.078l30.715 17.738v54.22l14.46 8.284c8.95 5.168 16.266 2.07 16.266-6.875V51.688c0-8.95-7.316-20.497-16.265-25.665zm0 0",
    fill: "#1d94dd"
  })));
};
export default SvgLogo;